var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m6.75 18.277-2.3 2.3c-.317.317-.68.388-1.088.213-.408-.175-.612-.488-.612-.938V4.277c0-.55.196-1.02.587-1.412a1.926 1.926 0 0 1 1.413-.588h16c.55 0 1.02.196 1.413.588.391.392.587.862.587 1.412v12c0 .55-.196 1.021-.587 1.413a1.926 1.926 0 0 1-1.413.587h-14Zm-.85-2h14.85v-12h-16v13.125l1.15-1.125Z",
  fill: "currentColor"
})));

export default SvgMessage;